import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import AddEditForm from 'js/magazine-issue/AddEdit/AddEditForm'
import { GET_ISSUE_EDIT } from 'js/magazine-issue/AddEdit/Edit/Edit.queries'

const Edit = () => {
    const { t } = useTranslation()
    const { guid } = useParams()

    const { loading, data } = useQuery(GET_ISSUE_EDIT, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity } = data

    return (
        <AddEditForm title={t('entity-magazine.edit-issue')} entity={entity} />
    )
}

export default Edit
